import type { AxiosInstance } from 'axios';

/**
 * Cliente do log geral de um SERVIÇO SATÉLITE (transversal/at-91, ADR 0062).
 *
 * Os satélites (Portal de Cotações, Requisições, banco-de-dados, FIPE) expõem a mesma rota que o
 * SOAC — `GET /audit-logs/geral*`, com a mesma forma de resposta —, e a tela Logs do sistema os lê
 * pela instância axios de cada um, que já leva o token do SOAC.
 *
 * ⚠️ As chamadas daqui não vão ao backend da Oficina, e por isso estão declaradas em
 * `EXTERNAS_CONHECIDAS` do extrator do contrato cross-repo. Sem nenhum catch: quem trata é a tela.
 */
export function clienteDoLogGeral(instancia: AxiosInstance) {
  return {
    listar: async (params: Record<string, string>) => (await instancia.get('/audit-logs/geral', { params })).data,
    opcoes: async () => (await instancia.get('/audit-logs/geral/opcoes')).data,
    detalhe: async (id: string) => (await instancia.get(`/audit-logs/geral/${encodeURIComponent(id)}`)).data,
    exportar: async (params: Record<string, string>) =>
      instancia.get('/audit-logs/geral/export', { params, responseType: 'blob' }),
  };
}

export type ClienteDoLogGeral = ReturnType<typeof clienteDoLogGeral>;
